<template>
  <div>
    <iframe id="frame" height="100%" width=100% :src="filePath" style="border: none" @load="load"></iframe>
  </div>
</template>

<script lang="ts">
import { isMobile } from "@/style/StyleHelpers";
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    fileUrl: {
      type: String
    },
    fullscreen: {
      type: Boolean
    },
    bookmarks: {
      type: Boolean
    }
  },
  data() {
    return {
      isMobile: isMobile(),
      pathToPdfJSViewer: 'lib/pdfjs-3.2.146-dist/web/viewer.html'
    };
  },
  computed: {
    filePath(): string {
      let res = 'this.pathToPdfJSViewer'
      if (this.fileUrl !== '') {
        res = this.pathToPdfJSViewer + '?file=' + this.fileUrl;
      }
      if (!this.bookmarks || this.isMobile) {
        res += "#pagemode=none&zoom=auto"
      } else {
        res += "#pagemode=bookmarks"
      }
      return res;
    }
  },
  methods: {
    load() {
      const iframe = document.getElementById('frame');
      // @ts-expect-error : generated method
      const innerDoc = (iframe.contentDocument) ? iframe.contentDocument : iframe.contentWindow.document;
      // Hide toolbar
      innerDoc.getElementById("toolbarViewerRight").classList.add("hidden");
      innerDoc.getElementById("openFile").classList.add("hidden");
      innerDoc.getElementById("print").classList.add("hidden");
      innerDoc.getElementById("editorFreeText").classList.add("hidden");
      innerDoc.getElementById("editorInk").classList.add("hidden");
      innerDoc.getElementById("secondaryToolbarToggle").classList.add("hidden");

    }
  }
})

</script>

<style scoped>
div {
  height: 72vh;
  min-width: 200px;
}

</style>
